import TalentsApi from '../../../TalentsApi';
import { useNavigate } from "react-router-dom";
import { t } from '../../../content';
import { useLocale } from '../../../locale';

function Logout() {
    const navigate = useNavigate();
    const { withLocale } = useLocale();

    function logout() {
        let obj = new TalentsApi();
        obj.logout();
        navigate(withLocale('/login'));
        window.location.reload();
    }

    return (
        <span className="logout" onClick={logout}>{t('nav.items.logout')}</span>
    );
}

export default Logout;
